export class ChargeEffect extends Phaser.Geom.Point {
  protected scene: Phaser.Scene;
  protected particles: Phaser.GameObjects.Particles.ParticleEmitterManager;
  // protected emitter: Phaser.GameObjects.Particles.ParticleEmitter;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(x, y);

    this.scene = scene;

    let line = new Phaser.Geom.Line(0, -100, 100, -100);
    this.particles = this.scene.add.particles('game', 'icon-charge.png');
    // this.particles = this.scene.make.particles({
    //   key: 'game',
    //   emitters: [
    //     {
    //       name: 'charge',
    //       frame: ['icon-charge.png'],
    //       angle: { min: 45, max: 180 - 45 },
    //       scale: { min: 0.15, max: 0.65 },
    //       speed: { min: 100, max: 200 },
    //         // moveToX: 1100,
    //         // moveToY: 50,
    //       gravityY: 100,
    //       lifespan: 4000,
    //       quantity: 1,
    //       emitZone: { source: line }
    //     }
    //   ]
    // });
    this.createEmitter();
  }

  public fire() {
    // let emitter = this.particles.emitters.getByName('charge');
    // emitter?.setScrollFactor(0, 0);
    // emitter?.explode(1, this.x - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY);

    this.emit();
    this.scene.time.delayedCall(10, this.emit, [10, -55], this);
    this.scene.time.delayedCall(30, this.emit, [-10, -45], this);
    this.scene.time.delayedCall(60, this.emit, [-20, -40], this);
    this.scene.time.delayedCall(90, this.emit, [20, -60], this);
    this.scene.time.delayedCall(120, this.emit, [-20, -50], this);
    this.scene.time.delayedCall(150, this.emit, [20, -50], this);

    // emitter?.explode(40, this.x - this.scene.cameras.main.scrollX - 5, this.y - this.scene.cameras.main.scrollY - 10);
    // emitter?.explode(40, this.x - this.scene.cameras.main.scrollX - 10, this.y - this.scene.cameras.main.scrollY - 5);
    // emitter?.explode(40, this.x - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY);
    // emitter?.explode(40, this.x - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY);
  }

  protected emit(offsetX: number = 0, offsetY: number = 0) {
    let emitter = this.particles.emitters.getByName('charge');
    // emitter?.setScrollFactor(0, 0);
    emitter?.explode(1, this.x - this.scene.cameras.main.scrollX + offsetX, this.y - this.scene.cameras.main.scrollY + offsetY);
  }

  protected createEmitter() {
    let zone = new Phaser.Geom.Circle(this.x, this.y, 100);
    let line = new Phaser.Geom.Line(0, -100, 1920, -100);

    let emitter = this.particles.createEmitter({
      name: 'charge',
      // on: false,
      speed: { min: 400, max: 900 },
      scale: { min: 0.5, max: 1 },
      angle: Phaser.Math.Angle.Between(this.x, this.y, 1100, 50) + Math.PI * 0.5,
      moveToX: 1100,
      moveToY: 55,
      lifespan: 750,
      quantity: 10,
      frequency: -1
    });

    emitter.scrollFactorX = 0;
    emitter.scrollFactorY = 0;
  }
}
